import { gql } from '@apollo/client';
import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import { CIError } from 'common/error/error_util';
import client from 'common/graphql/client';

import StudyDeleted from '../../module/studydeleted/studydeleted';

const GetStudyIsDeletedQuery = gql`
    query GetStudyIsDeleted($pk: String!) {
        getStudy(pk: $pk) {
            isDeleted
        }
    }
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function StudyRoute(props: any): ReactElement {
    const [isStudyAvailable, setIsStudyAvailable] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        client
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .query<any>({
                query: GetStudyIsDeletedQuery,
                variables: {
                    pk: props.studyId,
                },
            })
            .then((response) => {
                setIsStudyAvailable(!response.data.getStudy.isDeleted);
                setLoading(false);
            })
            .catch((err) => {
                throw CIError.fromGraphQLError(err);
            });
    }, [props.studyId]);

    const { component: Component } = props;

    return (
        <>
            {loading ? (
                <div className="loading-overlay__indicator-container">
                    <CircularProgress size={30} />
                </div>
            ) : (
                <>{isStudyAvailable ? <Component {...props} /> : <StudyDeleted />}</>
            )}
        </>
    );
}
